import { render } from "./calendar.area.vue?vue&type=template&id=19d4a42f"
import script from "./calendar.area.vue?vue&type=script&lang=js"
export * from "./calendar.area.vue?vue&type=script&lang=js"

import "./calendar.area.vue?vue&type=style&index=0&id=19d4a42f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__